export default __webpack_public_path__ + "static/media/hyper-hero.9a816f2f.mp4";